import React, { useState } from 'react';
import WarningsTab from './WarningsTab';
import ArchivesTab from './ArchivesTab';
import { ShieldAlert, FolderOpen } from 'lucide-react';

export default function DisciplineHome() {
  const [activeTab, setActiveTab] = useState('warnings');

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">الانضباط والأرشيف</h1>
          <p className="text-sm text-slate-500 mt-1">إدارة إنذارات وعقوبات التلاميذ وأرشيف الملفات</p>
        </div>
      </div>

      <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
        <div className="flex border-b border-slate-200">
          <button
            onClick={() => setActiveTab('warnings')}
            className={`flex-1 py-4 px-6 text-sm font-bold flex items-center justify-center gap-2 transition-colors ${
              activeTab === 'warnings'
                ? 'text-primary border-b-2 border-primary bg-primary/5'
                : 'text-slate-500 hover:text-slate-700 hover:bg-slate-50'
            }`}
          >
            <ShieldAlert className="w-5 h-5" />
            الإنذارات والعقوبات
          </button>
          <button
            onClick={() => setActiveTab('archives')}
            className={`flex-1 py-4 px-6 text-sm font-bold flex items-center justify-center gap-2 transition-colors ${
              activeTab === 'archives'
                ? 'text-primary border-b-2 border-primary bg-primary/5'
                : 'text-slate-500 hover:text-slate-700 hover:bg-slate-50'
            }`}
          >
            <FolderOpen className="w-5 h-5" />
            أرشيف الملفات
          </button>
        </div>

        <div className="p-6">
          {activeTab === 'warnings' ? <WarningsTab /> : <ArchivesTab />}
        </div>
      </div>
    </div>
  );
}
